<template>
    <div>HOVER WINDOW</div>
</template>

<script>
/* global google */

import { MapElementFactory } from 'vue2-google-maps'

export default MapElementFactory({
  name: 'hoverWindow',

  ctr: () => google.maps.OverlayView,

  events: [ 'click' ],

  mappedProps: {},

  props: {},

  beforeCreate () { console.log('beforeCreate') },

  afterCreate (instance) { console.log('afterCreate') },

  methods: {
    onAdd: function () {
      console.log('onAdd')
      // console.log('onAdd')
    },

    move: function (position) {
      console.log('move')
      // let divPosition = this.getProjection().fromLatLngToDivPixel(position)
      // console.log(divPosition)
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/HoverWindow.vue